import { getOnboardingRedirectPath, type OnboardingGateState } from '@/lib/auth/onboarding-access'

type HomeRouteOptions = {
  onboarding?: OnboardingGateState | null
  requestedRedirect?: string
}

export function resolveHomeRoute({ onboarding, requestedRedirect }: HomeRouteOptions) {
  const onboardingRedirect = getOnboardingRedirectPath(onboarding)

  if (onboardingRedirect) {
    return onboardingRedirect
  }

  return requestedRedirect ?? '/dashboard'
}
